import routineReducerFactory from "./routineReducerFactory";
import {fetchProductOrderHistory} from "../actions/routines";

const productOrderHistory = routineReducerFactory(fetchProductOrderHistory, {data: [], loading: true});

export default productOrderHistory;